import './polyfills.js';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';

import App from './App.jsx';
import CombinedProviders from '@context/CombinedProviders';
import ErrorFallback from '@ui/ErrorFallback';

import './index.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container not found');
}
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <CombinedProviders>
          <App />
        </CombinedProviders>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
